module.exports = __webpack_public_path__ + "assets/img/1281587028519_.pic_hd.52af5d7b.jpg";